import { toStr } from '@enonic/js-utils/value/toStr';
import {
	ZodTypeAny,
	ZodAny,
	ZodArray,
	ZodBoolean,
	ZodDate,
	ZodEnum,
	ZodEffects,
	// ZodIntersection,
	ZodLiteral,
	ZodNumber,
	ZodObject,
	ZodOptional,
	ZodRawShape,
	ZodString,
	ZodUnion,
} from 'zod';

function defaultValueFromSchema({
	path,
	schema,
}: {
	path: string;
	schema: ZodTypeAny;
}): 0 | "" | never[] | null | undefined {
	if (schema instanceof ZodString) {
		return '';
	}

	if (schema instanceof ZodNumber) {
		return 0;
	}

	if (schema instanceof ZodBoolean) {
		return null;
	}

	if (schema instanceof ZodArray) {
		return [];
	}

	if (schema instanceof ZodDate) {
		return null;
	}

	if (schema instanceof ZodEnum) {
		return undefined;
		// emptystring works, null causes:
		// Warning: `value` prop on `input` should not be null.
		// Consider using an empty string to clear the component or `undefined` for uncontrolled components.
		// return '';
	}

	if (schema instanceof ZodOptional) {
		return defaultValueFromSchema({ // recurse
			path,
			schema: (schema as ZodOptional<ZodTypeAny>)._def.innerType,
		});
	}

	if (schema instanceof ZodEffects) {
		return defaultValueFromSchema({ // recurse
			path,
			schema: (schema as ZodEffects<ZodTypeAny>)._def.schema,
		});
	}

	if (schema instanceof ZodUnion) {
		return undefined;
	}

	if (schema instanceof ZodAny) { // z.instanceof(File)
		return undefined;
	}

	if (schema instanceof ZodLiteral) {
		return undefined;
	}

	console.error('defaultValueFromSchema path:', path, 'Unsupported Zod type', schema);
	throw new Error(`defaultValueFromSchema path:${path} Unsupported Zod type:${toStr(schema)}`);
}


export function generateDefaultValues(schema: ZodObject<ZodRawShape>): Record<string, unknown> {
	const defaultValues: Record<string, unknown> = {};

	if (!(schema instanceof ZodObject)) {
		return {};
	}

	for (const key in schema.shape) {
		const fieldSchema = schema.shape[key];
		if (fieldSchema instanceof ZodObject) {
			defaultValues[key] = generateDefaultValues(fieldSchema); // recurse
		} else {
			defaultValues[key] = defaultValueFromSchema({
				path: key,
				schema: fieldSchema,
			});
		}
	} // for

	return defaultValues;
}
